import { Factory } from '@infodata-group/inf-commons';
import { VigiMenu } from '../model/vigi-menu';
import { BackOfficeVigiMenuInterface } from '../interface/back-office/back-office-vigi-menu.interface';
import { FactoryVigiMenuItem } from './factory-vigi-menu-item';

export class FactoryVigiMenu implements Factory<VigiMenu> {
  build(o: BackOfficeVigiMenuInterface): VigiMenu {
    return new VigiMenu(
      o.id,
      o.items.map(i => new FactoryVigiMenuItem().build(i))
    );
  }

  getApi(): string {
    return 'menu/';
  }
}
